export default __webpack_public_path__ + "static/media/l_wdt_c_0_1.4470ba9d.mp3";